import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myPercentPipe',
})
export class MyPercentPipe implements PipeTransform {
    percentSymbol: string = '%';

    transform(numberToFormat: any): string {
        return numberToFormat + this.percentSymbol;
    }
}
